import React, { FC } from 'react';

import cn from 'classnames';

import { TrashBinIcon, LaunchLinkIcon, UsersIcon } from 'src/atoms';

import styles from 'src/components/workspaces-components/styles.module.scss';
import { TRUNCATE_NAME_WIDTH, WORKSPACE_COL_IDS } from './constants';
import { ColumnAlignOptions, TableHeaderColumns } from 'src/interfaces';
import truncate from 'lodash/truncate';
import { formatDateFromJSON } from 'src/helpers';
import { LOAN_TABLE_DATE_FORMAT } from 'src/constants/globalConstants';
import { TCompanyWorkspace } from 'src/interfaces/workspacesReduxShapes';
import { WORKSPACE_ACTIONS } from 'src/constants/workspacesConstants';

type ActionsBlockProps = {
  workspaceName: string;
  workspaceId: string;
  onGoToAccess: () => void;
  onActionClick: (action: WORKSPACE_ACTIONS, workspaceName?: string, workspaceId?: string) => void;
};

export const WORKSPACES_TABLE_HEADINGS_LIST: TableHeaderColumns = [
  {
    label: 'Workspace Name',
    id: WORKSPACE_COL_IDS.NAME,
    isSortable: false,
    isOpen: false,
    width: 70,
    sortOptions: null,
    align: ColumnAlignOptions.LEFT
  },
  {
    label: 'Created at',
    id: WORKSPACE_COL_IDS.CREATED,
    width: 15,
    isSortable: false,
    isOpen: false,
    sortOptions: null,
    align: ColumnAlignOptions.CENTER
  },
  {
    label: 'Actions',
    id: WORKSPACE_COL_IDS.ACTIONS,
    width: 15,
    isSortable: false,
    isOpen: false,
    sortOptions: null,
    align: ColumnAlignOptions.CENTER
  }
];

export const renderTableContent = (
  colId: WORKSPACE_COL_IDS,
  row: TCompanyWorkspace,
  onGoToAccess: (id: string) => void,
  onActionClick: (action: WORKSPACE_ACTIONS, workspaceName: string, workspaceId: string) => void
): JSX.Element => {
  switch (colId) {
    case WORKSPACE_COL_IDS.NAME: {
      const name = truncate(row?.name, { length: TRUNCATE_NAME_WIDTH }).trim();

      return <span className={cn(styles.tableText, styles.tableName)}>{name}</span>;
    }

    case WORKSPACE_COL_IDS.CREATED: {
      const formattedCreated = row?.created_at
        ? formatDateFromJSON(new Date(row?.created_at), LOAN_TABLE_DATE_FORMAT)
        : '-';

      return <span className={styles.tableText}>{formattedCreated}</span>;
    }

    case WORKSPACE_COL_IDS.ACTIONS:
      return (
        <ActionsBlock
          workspaceName={row.name}
          workspaceId={row.id}
          onGoToAccess={() => onGoToAccess(row.id)}
          onActionClick={onActionClick}
        />
      );

    default:
      return <></>;
  }
};

const ActionsBlock: FC<ActionsBlockProps> = ({ onActionClick, onGoToAccess, workspaceName, workspaceId }) => {
  return (
    <div className={styles.actions}>
      <button className={styles.actionBtn} type="button" onClick={() => onGoToAccess()}>
        <UsersIcon />
        <span className={styles.actionPopover}>See users access</span>
      </button>

      <button
        className={styles.actionBtn}
        type="button"
        onClick={() => onActionClick(WORKSPACE_ACTIONS.EDIT_WORKSPACE, workspaceName, workspaceId)}
      >
        <LaunchLinkIcon />
        <span className={styles.actionPopover}>Edit workspace</span>
      </button>

      <button
        className={styles.actionBtn}
        type="button"
        onClick={() => onActionClick(WORKSPACE_ACTIONS.DELETE, workspaceName, workspaceId)}
      >
        <TrashBinIcon />
        <span className={styles.actionPopover}>Delete workspace</span>
      </button>
    </div>
  );
};
